module.exports = __webpack_public_path__ + "img/vjetrenjaca-3.ee5c1625.jpg";